import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { ButtonComponent } from '../../../../ui/components/atoms/button/button.component';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-deactivate-alarms',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent, TranslocoDirective],
  template: `
    <ng-container *transloco="let t">
      <ui-button
        buttonType="primary"
        buttonShape="round"
        icon="icons:bell-off"
        class="!text-white"
        [disabled]="disabled()"
        (buttonClick)="onDebounceClick()"
      >
        {{ t('DISTRIBUTION_NETWORK.DEACTIVE_ALARMS') }}
      </ui-button>
    </ng-container>
  `,
})
export class DeactivateAlarmsComponent {
  debounceClick = output<void>();
  disabled = input<boolean>(false);

  onDebounceClick() {
    this.debounceClick.emit();
  }
}
